const CardData8 = [
  {
    title: 'Solomun',
    description:
      'Solomun, cuyo nombre real es Mladen Solomun, es un destacado DJ y productor bosnio-alemán nacido el 27 de diciembre de 1975 en Travnik, Bosnia y Herzegovina. Se trasladó a Hamburgo con su familia, donde creció y desarrolló su pasión por la música. Influenciado por cintas de clubes nocturnos que le compartía su primo, comenzó a pinchar a los 16 años y, posteriormente, a producir música a los 23. En 2005, fundó el sello discográfico Diynamic junto a Adriano Trolio, seguido en 2010 por 2DIY4 para proyectos experimentales. Su remix de "Around" de Noir & Haze fue nombrado Remix del Año por Resident Advisor en 2011, y en 2012 recibió el reconocimiento de DJ del Año por Mixmag y Productor del Año en los DJ Awards. Su música combina house con influencias de hip-hop, soul y funk, caracterizada por líneas de bajo profundas y melodías eufóricas. Ha mantenido residencias en Ibiza, como Solomun +1 en Pacha, y ha actuado en festivales como Tomorrowland y Ultra Europe. En 2018, colaboró con Rockstar Games apareciendo como DJ en Grand Theft Auto Online y produciendo un video musical dentro del motor del juego. Solomun es reconocido por redefinir la música house moderna y por su impacto global en la escena electrónica.',
    videourl:
      'https://youtube.com/playlist?list=PLp7Nj6O7KJ9eFWI_mjZ-rVY8dK-aRHXLq&si=sTf2Gzzw_3xTnbNh',
    price: 80,
    coverImg: 'solomun.jpg',
    category: 'Electronica',
    location: 'Germany',
    locationImg: 'germany.jpeg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://solomun.org//',
    youtube: 'https://www.youtube.com/channel/UCN8v8tNOCmaZaN-t4ynDdEA',
    facebook: 'https://www.facebook.com/SolomunMusic/',
    instagram: 'https://www.instagram.com/solomun/',
    twitter: 'https://x.com/SolomunMusic',
    spotify: 'https://open.spotify.com/artist/5wJK4kQAkVGjqM9x46KQOC',
    deezer: 'https://www.deezer.com/de/artist/179975',
    apple: 'https://music.apple.com/us/artist/solomun/2007791453',
    soundcloud: 'https://soundcloud.com/solomun',
    tidal: 'https://listen.tidal.com/artist/4792224',
    wiki: 'https://en.wikipedia.org/wiki/Solomun_(musician)',
    ticketmaster:
      'https://www.ticketmaster.com/solomun-tickets/artist/1874637',
    tiktok: 'https://www.tiktok.com/@solomun_king',
    napster: 'https://music.amazon.de/artists/B001T1IQXM?tab=CATALOG',
  }, 
  {
    title: 'Tinlicker',
    description:
      'Tinlicker es un grupo de música electrónica de Utrecht, Países Bajos, compuesto por Micha Heyboer y Jordi van Achthoven. Formado en 2012, han lanzado música en sellos como Anjunadeep, mau5trap, Astralwerks y Armada, y han participado en festivales como Mysteryland, Creamfields, Tomorrowland y Ultra. Tinlicker comenzó como un proyecto en solitario de Micha Heyboer (nacido el 14 de mayo de 1979 en Utrecht) bajo su propio sello Zero Three Zero, con el lanzamiento del EP It’s My First Time Here (7 de diciembre de 2012) y el álbum Remember The Future (8 de abril de 2013). En 2014, Micha se unió con Jordi van Achthoven (nacido el 4 de junio de 1983 en Gouda) tras un contacto mutuo, compartiendo influencias como Paul Kalkbrenner, Trentemøller y Moderat. Decidieron formar un dúo y colaboraron con el sello Sotto Voce de Feed Me, lanzando tres EPs: Like No Other (1 de diciembre de 2014), Into The Open (14 de abril de 2015) y The Space In Between (4 de septiembre de 2015), este último destacando con "Oudegracht". En 2016, el sub-sello Zerothree de Toolroom lanzó "Maandag" el 5 de febrero, que fue presentado por Above & Beyond en su programa de radio Group Therapy. Ese mismo año, Zerothree también publicó el EP Automatic, que incluyó "In All The Fire", estrenado en Data Transmission.',
    videourl:
      'https://youtube.com/playlist?list=OLAK5uy_mz6uTlU72G73QeW6mA0ET0ndpD4p0Z_nE&si=XGFguXwOdnqHCmt-',
    price: 80,
    coverImg: 'tinlicker.jpg',
    category: 'Electronica',
    location: 'Ucrania',
    locationImg: 'ukraine.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://www.tinlicker.com/',
    youtube: 'https://www.youtube.com/channel/UC5loBF2icmNE4vf86RuS5Ww',
    facebook: 'https://www.facebook.com/tinlicker',
    instagram: 'https://www.instagram.com/tinlicker/',
    twitter: 'https://x.com/tinlicker_nl',
    spotify: 'https://open.spotify.com/artist/5EmEZjq8eHEC6qFnT63Lza',
    deezer: 'https://www.deezer.com/mx/artist/4105090',
    apple: 'https://music.apple.com/mx/artist/tinlicker/580400483',
    soundcloud: 'https://soundcloud.com/tinlicker',
    tidal: 'https://listen.tidal.com/artist/4792224',
    wiki: 'https://en.wikipedia.org/wiki/Tinlicker',
    ticketmaster:
      'https://www.ticketmaster.com/tinlicker-tickets/artist/2539619',
    tiktok: 'https://www.tiktok.com/@tinlicker',
    napster: 'https://music.amazon.com.mx/artists/B00AAMAMJW/tinlicker',
  }, {
    title: 'Korolova',
    description:
      'Olga Korolova (Chernihiv, Ucraria; 17 de marzo de 1988), conocida profesionalmente como Korolova, es una productora musical y DJ ucraniana. Produce principalmente música house melódica y techno. En 2023, Korolova realizó más de 100 actuaciones en 50 países ​ y acumula más de 100 millones de visitas en su canal de YouTube, así como más de 70 millones de reproducciones de audio y acumuló más de 500 mil seguidores en TikTok . También actuó en el escenario principal del festival de música belga Tomorrowland, en EDC Las Vegas, Untold en Rumania, NEON Countdown, So Track Boa, y colaboró con los sellos discográficos como Tomorrowland Music, Insomniac y Anjunabeats .Korolova ha lanzado temas bajo sellos discográficos como Ultra Records, Armada, AFTR:HRS y Get Physical Music; antes de crear su propio sello, Captive Soul. Ha actuado en lugares icónicos como Space Miami, Green Valley Brazil y Hi Ibiza; también ha retransmitido en directo desde hermosos lugares como Miami, Israel, Nueva York y Kiev .En 2024, Korolova asistió a su primera semana de la moda en París como primer paso para ingresar al mundo de la moda. ​Además actuó en festivales como el alemán Parookaville o el Tomorrowland en Bélgica.',
    videourl:
      'https://youtube.com/playlist?list=OLAK5uy_nFActIcUoxzd4SwvKd7iub5YoQ0IJrAiE&si=anZAeWWfkykqXDgA',
    price: 80,
    coverImg: 'korolova.jpg',
    category: 'Electronica',
    location: 'Ucrania',
    locationImg: 'ukraine.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://ra.co/dj/korolova/tour-dates',
    youtube: 'https://www.youtube.com/@KOROLOVADJ',
    facebook: 'https://www.facebook.com/korolova.dj',
    instagram: 'https://www.instagram.com/korolova.dj/',
    twitter: 'https://x.com/korolovamusik',
    spotify: 'https://open.spotify.com/artist/0I6oCyQQ1Q50q97y9B9gAx',
    deezer: 'https://www.deezer.com/mx/artist/121616272',
    apple: 'https://music.apple.com/mx/artist/korolova/1551178296',
    soundcloud: 'https://soundcloud.com/korolovadj',
    tidal: 'https://listen.tidal.com/artist/23280232',
    wiki: 'https://es.wikipedia.org/wiki/Korolova_(DJ)',
    ticketmaster:
      'https://ra.co/dj/korolova/tour-dates',
    tiktok: 'https://www.tiktok.com/@korolova.dj?',
    napster: 'https://music.amazon.com.mx/artists/B08V9HBQQQ/korolova',
  },
  {
    title: 'Boris Brejcha',
    description:
      'Boris Brejcha (Ludwigshafen am Rhein, 26 de noviembre de 1981) es un disc-jockey y productor alemán.1​ Él mismo ha definido su estilo como una evolución del Minimal techno y es actualmente conocido por ser uno de los exponentes más importantes del género.Boris Brejcha nació en Ludwigshafen (Alemania) en 1981, en su infancia tuvo que vivir algunos golpes del destino. A la edad de seis años, resultó gravemente herido en el desastre aéreo de Ramstein y pasó meses en el hospital. Hoy, todavía tiene cicatrices extensas de las quemaduras graves. Boris Brejcha desde su infancia mostró aptitudes musicales al aprender a tocar batería al lo que posteriormente tocaría en una banda durante medio año​. Poco tiempo después, a través de un compañero de clase escuchó un CD del evento de techno holandés Thunderdome, lo que significó su primera experiencia con el género.​ A la edad de doce años, empezó a producir música electrónica aunque no contaba con representación de ningún sello discográfico.En 2006, finalmente comenzó su carrera como productor de techno con el sello Autist Records con sus dos singles Monster y Yellow Kitchen. En el mismo año tuvo su primera aparición como DJ en el Festival Universo Parallelo en Brasil . Un año más tarde fue nombrado "Talento excepcional 2007" por la revista Raveline. En 2015, Brejcha fundó después de varios años de cooperación exitosa con la discográfica Harthouse su propio sello discográfico, al que llamó Fckng Serious. Además de él, los músicos Deniz Bul, Ann Clue y el dúo Theydream están bajo contrato con la etiqueta.',
    videourl:
      'https://youtube.com/playlist?list=OLAK5uy_nOdgC_PKy1AdNc6LyxJNobKvUAHxtqnWA&si=FW4nfzKceN5UVNHS',
    price: 80,
    coverImg: 'BorisBrejcha.jpg',
    category: 'Electronica',
    location: 'Alemania',
    locationImg: 'germany.jpeg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://www.borisbrejcha.de/',
    youtube: 'https://www.youtube.com/channel/UCukezONa4veoJBeK9UuVZew',
    facebook: 'https://www.facebook.com/BorisBrejcha.Official',
    instagram: 'https://www.instagram.com/borisbrejcha/?hl=de',
    twitter: 'https://x.com/BB_BORISBREJCHA',
    spotify: 'https://open.spotify.com/artist/6caPJFLv1wesmM7gwK1ACy?',
    deezer: 'https://www.deezer.com/mx/artist/133863',
    apple: 'https://music.apple.com/de/artist/boris-brejcha/202970860',
    soundcloud: 'https://soundcloud.com/boris-brejcha',
    tidal: 'https://listen.tidal.com/artist/3588686',
    wiki: 'https://es.wikipedia.org/wiki/Boris_Brejcha',
    ticketmaster:
      'https://www.ticketmaster.com/boris-brejcha-tickets/artist/2468693',
    tiktok: 'https://www.tiktok.com/@borisbrejcha?lang=de-DE',
    napster: 'https://music.amazon.com.mx/artists/B001C3W0JS/boris-brejcha',
  },
  {
    title: 'Jan Blomqvist',
    description:
      'Jan Blomqvist es un productor, cantante y compositor de música electrónica originario de Alemania. Es conocido por su estilo único que fusiona géneros como el deep house, el techno y la electrónica melódica. Su música se caracteriza por una atmósfera emotiva, donde a menudo combina voces cautivadoras, instrumentos en vivo y producción electrónica.Blomqvist comenzó a ganar reconocimiento en la escena de la música electrónica con su exitoso tema "The Space in Between", y desde entonces ha logrado un fuerte seguimiento por sus presentaciones en vivo, que suelen mezclar DJ sets con actuaciones en vivo de músicos. Su estilo tiene una profundidad emocional notable, abordando temas como la introspección, la conexión humana y la exploración personal.Además de su carrera en estudio, Jan Blomqvist ha tocado en importantes festivales y clubes internacionales, llevando su sonido atmosférico a una audiencia global. Su música crea una experiencia envolvente que invita a la reflexión, siendo ideal para quienes buscan una mezcla de lo electrónico con lo emocional..',
    videourl:
      'https://youtube.com/playlist?list=PLYspVfLYrIBeAvFN6ONTNHQeWIxgLLtGW&si=FLVBTCuHN00PBps9',
    price: 80,
    coverImg: 'janblomqvist.jpg',
    category: 'Electronica',
    location: 'Alemania',
    locationImg: 'germany.jpeg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://www.janblomqvist.com/',
    youtube: 'https://www.youtube.com/channel/UCAoNQvV7GbFixxDTxbpPAyQ',
    facebook: 'https://www.facebook.com/blomqvist.music',
    instagram: 'https://www.instagram.com/janblomqvist_official/',
    twitter: 'https://x.com/JanBlomqvist_',
    spotify: 'https://open.spotify.com/artist/5wMlMjOLeJfS5DfxqGfm83?',
    deezer: 'https://www.deezer.com/mx/artist/1656026',
    apple: 'https://music.apple.com/mx/artist/jan-blomqvist/468500851',
    soundcloud: 'https://soundcloud.com/janblomqvist',
    tidal: 'https://listen.tidal.com/artist/4560292',
    wiki: 'https://de.wikipedia.org/wiki/Jan_Blomqvist',
    ticketmaster:
      'https://www.ticketmaster.com/jan-blomqvist-tickets/artist/2550753',
    tiktok: 'https://www.tiktok.com/@janblomqvist_official?lang=es',
    napster: 'https://music.amazon.com.mx/artists/B00646UPJA/jan-blomqvist',
  },
  {
    title: 'deadmau5',
    description:
      'Joel Thomas Zimmerman (born January 5, 1981),[2] known professionally as Deadmau5 (stylized as deadmau5; pronounced dead-mouse), is a Canadian electronic music producer and DJ. He mainly produces progressive house music, though he also produces and DJs other genres of electronic music, including techno under the alias Testpilot. Zimmerman has received six Grammy Award nominations for his work.',
    videourl:
      'https://www.youtube.com/playlist?list=PLF-cRDh2mrlUcNzJGKMThzommWcCY6crU',
    price: 80,
    coverImg: 'deadmau5.jpg',
    category: 'Electronica',
    location: 'Canada',
    locationImg: 'canada.jpeg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://deadmau5.com/',
    youtube: 'https://www.youtube.com/c/deadmau5',
    facebook: 'https://www.facebook.com/deadmau5',
    instagram: 'https://www.instagram.com/deadmau5/',
    twitter: 'https://twitter.com/deadmau5',
    spotify: 'https://open.spotify.com/artist/2CIMQHirSU0MQqyYHq0eOx',
    deezer: 'https://www.deezer.com/mx/artist/142381',
    apple: 'https://music.apple.com/mx/artist/deadmau5/78011850',
    soundcloud: 'https://soundcloud.com/deadmau5',
    tidal: 'https://listen.tidal.com/artist/3523908',
    wiki: 'https://en.wikipedia.org/wiki/Deadmau5',
    ticketmaster:
      'https://www.ticketmaster.com/deadmau5-tickets/artist/1221074',
    tiktok: 'https://www.tiktok.com/@deadmau5?lang=es',
    napster: 'https://music.amazon.com.mx/artists/B000QKNU1U/deadmau5',
  },
  {
    title: 'Tiësto',
    description:
      'AFTR:HRS es un sello discográfico fundado por el DJ y productor discográfico neerlandés Tiësto, en el abril de 2016. La etiqueta se centra principalmente en deep house. El primer lanzamiento del sello fue Nungwi del BLR, que alcanzó el número nueve en el Beatport Deep House Top 100.',
    videourl:
      'http://youtube.com/playlist?list=PLAxy1YpvZDdVIC-7zyVo0jgi5l7RuyWui',
    price: 80,
    coverImg: 'tiesto.jpg',
    category: 'Electronica',
    location: 'Italia',
    locationImg: 'italy.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://www.tiesto.com/',
    youtube: 'https://www.youtube.com/c/tiesto',
    facebook: 'https://www.facebook.com/tiesto',
    instagram: 'https://www.instagram.com/tiesto/',
    twitter: 'https://twitter.com/tiesto',
    spotify: 'https://open.spotify.com/artist/2o5jDhtHVPhrJdv3cEQ99Z',
    deezer: 'https://www.deezer.com/mx/artist/434',
    apple: 'https://music.apple.com/mx/artist/ti%C3%ABsto/4091218',
    soundcloud: 'https://soundcloud.com/tiesto',
    tidal: 'https://listen.tidal.com/artist/3559128',
    wiki: 'https://es.wikipedia.org/wiki/Ti%C3%ABsto',
    ticketmaster:
      'https://www.ticketmaster.com.mx/tiesto-boletos/artist/834120',
    tiktok: 'https://www.tiktok.com/@tiesto?lang=es',
    napster: 'https://music.amazon.com.mx/artists/B000XKKZ4S/ti%C3%ABsto',
  },
  {
    title: 'David Guetta',
    description:
      'Pierre David Guetta(París, 7 de noviembre de 1967) es un DJ y productor francés de origen italiano, marroquí y belga. Actualmente, ocupa el puesto #1 según la encuesta realizada por DJ Magazine. Se inició como tal en varias discotecas durante las décadas de 1980 y de 1990, antes de fundar Gum Productions y lanzar su primer álbum: Just a Little More Love. Años más tarde llegarían Guetta Blaster y Pop Life.',
    videourl:
      'https://youtube.com/playlist?list=PLz1iM8YfFbTfnLTupp_Ps49dv1MXoCaep',
    price: 80,
    coverImg: 'davidGuetta.jpg',
    category: 'Electronica',
    location: 'Italia',
    locationImg: 'italy.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://davidguetta.com/',
    youtube: 'https://www.youtube.com/channel/UC1l7wYrva1qCH-wgqcHaaRg',
    facebook: 'https://www.facebook.com/DavidGuetta',
    instagram: 'https://www.instagram.com/davidguetta/',
    twitter: 'https://twitter.com/davidguetta',
    spotify: 'https://open.spotify.com/artist/1Cs0zKBU1kc0i8ypK3B9ai',
    deezer: 'https://www.deezer.com/mx/artist/542',
    apple: 'https://music.apple.com/mx/artist/david-guetta/5557599',
    soundcloud: 'https://soundcloud.com/davidguetta',
    tidal: 'https://listen.tidal.com/artist/27343',
    wiki: 'https://es.wikipedia.org/wiki/David_Guetta',
    ticketmaster:
      'https://www.ticketmaster.com/david-guetta-tickets/artist/1109508',
    tiktok: 'https://www.tiktok.com/@davidguetta?lang=es',
    napster: 'https://music.amazon.com.mx/artists/B000SXBQ0W/david-guetta',
  },
  {
    title: 'Armin Van Buren',
    description:
      'Armin Jozef Jacobus Daniël van Buuren ; Leiden, Países Bajos; 25 de diciembre de 1976) es un DJ y productor discográfico neerlandés. Según el ranking elaborado por DJ Mag, ha sido nombrado DJ número uno del mundo en 2007, 2008, 2009, 2010 y 2012, siendo el único hasta la fecha en conseguir este galardón cuatro veces consecutivas y cinco veces en total.',
    videourl:
      'https://www.youtube.com/playlist?list=PL0cWlOyqP6_ML2mhXbrwIRQ8ITpugDZh3',
    price: 80,
    coverImg: 'ArminVanBuren.jpg',
    category: 'Electronica',
    location: 'Netherlands',
    locationImg: 'Netherlands.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://www.arminvanbuuren.com/',
    youtube: 'https://www.youtube.com/user/arminvanbuuren',
    facebook: 'https://www.facebook.com/arminvanbuuren',
    instagram: 'https://www.instagram.com/arminvanbuuren/',
    twitter: 'https://twitter.com/ArminvanBuuren',
    spotify: 'https://open.spotify.com/artist/0SfsnGyD8FpIN4U4WCkBZ5',
    deezer: 'https://www.deezer.com/mx/artist/10620',
    apple: 'https://music.apple.com/mx/artist/armin-van-buuren/17976294',
    soundcloud: 'https://soundcloud.com/arminvanbuuren',
    tidal: 'https://listen.tidal.com/artist/27343',
    wiki: 'https://es.wikipedia.org/wiki/Armin_van_Buuren',
    ticketmaster:
      'https://www.ticketmaster.com/armin-van-buuren-tickets/artist/878620',
    tiktok: 'https://www.tiktok.com/@arminvanbuuren?lang=es',
    napster: 'https://music.amazon.com.mx/artists/B000QJVYJG/armin-van-buuren',
  },

  {
    title: 'Mark Farina',
    description:
      "Mark Farina (born March 25, 1969 in Chicago, Illinois, USA) is an American disc jockey and musician, known for his Chicago house, acid jazz and downtempo works. His notable releases include Mood (KMS Records, 1989) and the Mushroom Jazz series (Om Records, 1996–2011), and recently known also from house compilations El Divinio. He is primarily identified with the house music scene based in San Francisco, California. Farina currently resides in Dallas, Texas.Shortly after Farina became friends with Derrick Carter in 1988 at a record store in Chicago, he developed an interest in house music. Farina experimented with a deeper style, dropping De La Soul, disco classics and other styles not being played in the main rooms of nightclubs. While exploring purist forms of house music, Farina developed his trademark style, known as mushroom jazz: acid jazz infused with the West Coast's jazzy, organic productions along with urban beats.",
    videourl:
      'https://youtube.com/playlist?list=OLAK5uy_k8lhsYmCtEzylloeQhTdKuyakQlAMkYMM',
    price: 80,
    coverImg: 'markfarina.jpg',
    category: 'Electronica',
    location: 'USA',
    locationImg: 'usaflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'djmarkfarina.ne',
    youtube: 'https://www.youtube.com/channel/UCmt4f0zzI5PjFmyxcDNPSsQ',
    facebook: 'https://www.facebook.com/DJMarkFarina',
    instagram: 'https://www.instagram.com/djmarkfarina/',
    twitter: 'https://twitter.com/djmarkfarina',
    spotify: 'https://open.spotify.com/artist/3Nk2T3DZVBvPRO5BBSrklE',
    deezer: 'https://www.deezer.com/mx/artist/1578182',
    apple: 'https://music.apple.com/mx/artist/mark-farina/2856635',
    soundcloud: 'https://soundcloud.com/djmarkfarina',
    tidal: 'https://listen.tidal.com/artist/3529070',
    wiki: 'https://en.wikipedia.org/wiki/Mark_Farina',
    ticketmaster:
      'https://www.ticketmaster.com/mark-farina-tickets/artist/836585',
    tiktok: 'https://www.tiktok.com/@markfarina1?lang=es',
    napster: 'https://music.amazon.com.mx/artists/B000RW0WP4/mark-farina',
  },
  {
    title: 'Nacional Records',
    description:
      'Nacional Records es una compañía discográfica independiente fundada en el 2005 por Tomas Cookman, que es uno de los pocos sellos que distribuye música en español y rock en español, aparte de distribuir música latina y distintos géneros musicales, que se enfocan especialmente en Latinoamérica y España. Incluyendo artistas de Chile, Colombia, México, Argentina, Venezuela, Ecuador, entre otros.',
    videourl: 'https://youtube.com/playlist?list=UUK_7uFzY1qxGpT3BiYHAoxg',
    price: 80,
    coverImg: 'nacionalrecords.jpg',
    category: 'Electronica',
    location: 'Los Angeles,Ca',
    locationImg: 'mexiflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://nacionalrecords.com/',
    youtube: 'https://www.youtube.com/c/Nacionalrecords',
    facebook: 'https://www.facebook.com/nacionalrecords',
    instagram: 'https://www.instagram.com/nacionalrecords/',
    twitter: 'https://twitter.com/NacionalRecords',
    spotify: 'https://open.spotify.com/user/nacionalrecords',
    deezer: 'https://www.deezer.com/mx/artist/597546',
    apple:
      'https://music.apple.com/mx/album/friend-single/1548829793?i=1548829797',
    soundcloud: 'https://soundcloud.com/nacional-records',
    tidal:
      'https://listen.tidal.com/playlist/81531e2b-bf4f-4782-b6e8-2b9eadcf9952',
    wiki: 'https://es.wikipedia.org/wiki/Nacional_Records',
    ticketmaster: 'https://www.ticketmaster.com/',
    tiktok: 'https://www.tiktok.com/@nacionalrecords',
    napster: 'https://music.amazon.com.mx/artists/B000QJRZHQ/nortec-collective',
  },
  {
    title: 'Alan Walker ',
    description:
      'Alan Olav Walker (born 24 August 1997) is a British-born Norwegian DJ, YouTuber and record producer primarily known for the critically acclaimed single Faded (2015), which was certified platinum in 14 countries. He has also made several songs including Sing Me to Sleep, Alone, Darkside, and On My Way, all of which attracted millions of views on YouTube.',
    videourl:
      'https://www.youtube.com/playlist?list=PL0cWlOyqP6_ML2mhXbrwIRQ8ITpugDZh3',
    price: 80,
    coverImg: 'alanwalker.jpg',
    category: 'Electronica',
    location: 'Norway',
    locationImg: 'norway.jpeg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://store.alanwalker.com/',
    youtube: 'https://www.youtube.com/channel/UCJrOtniJ0-NWz37R30urifQ',
    facebook: 'https://www.facebook.com/alanwalkermusic',
    instagram: 'https://www.instagram.com/alanwalkermusic/',
    twitter: 'https://twitter.com/IAmAlanWalker',
    spotify: 'https://open.spotify.com/artist/7vk5e3vY1uw9plTHJAMwjN',
    deezer: 'https://us.napster.com/artist/alan-walker',
    apple: 'https://music.apple.com/mx/artist/alan-walker/1062085272',
    soundcloud: 'https://soundcloud.com/alanwalker',
    tidal: 'https://listen.tidal.com/artist/6159368',
    wiki: 'https://en.wikipedia.org/wiki/Alan_Walker',
    ticketmaster:
      'https://www.ticketmaster.com/alan-walker-tickets/artist/2216743',
    tiktok: 'https://www.tiktok.com/@alanwalkermusic?lang=es',
    napster: 'https://music.amazon.com.mx/artists/B0013FJCOG/alan-walker',
  },
  {
    title: 'Paul Van Dyke',
    description:
      'Matthias Paul (Eisenhüttenstadt, Brandenburgo; 16 de diciembre de 1971), más conocido por su nombre artístico Paul van Dyk, es un DJ de música trance y productor alemán de renombre mundial. En 2010 fue considerado el sexto mejor DJ del mundo por TheDjList, así como el quinto mejor DJ del mundo según las votaciones de DJmag, la cual le concedió el primer lugar en los años 2005 y 2006.​ Actualmente se encuentra en el puesto 38 según la revista DJmag.Nacido en Eisenhüttenstadt, Brandeburgo, Alemania, comenzó su carrera musical en el club berlinés Turbine en 1991. Cuando van Dyk nació, Eisenhüttenstadt se encontraba en la República Democrática Alemana por lo cual tuvo que valerse del contrabando de casetes de música que provenían del extranjero para poder escuchar la música de aquella época. Fue entonces cuando Paul comenzó a hacer mezclas de canciones para sus amigos. Cuando cayó el Muro de Berlín Paul pudo florecer como músico. Se inició en Turbine. Fue en esta discoteca donde un amigo le sugirió que siguiera mezclando después de oír algunas de sus mezclas en casete, y fue así como inició su carrera.',
    videourl:
      'https://youtube.com/playlist?list=PLtsi3zUEpVIzuj--yrZ3ZDPfQSYKgzSQx&si=8TAIXt203k38AD7R',
    price: '$50',
    coverImg: 'paulvandyk.jpg',
    category: 'Electronica',
    location: 'UK',
    locationImg: 'germany.jpeg',
    openSpots: null,
    likes: null,
    websiteurl: 'https://www.paulvandyk.com/',
    youtube: 'https://www.youtube.com/@PaulvanDyk',
    facebook: 'https://www.facebook.com/PVD',
    instagram: 'https://www.instagram.com/paulvandyk/ ',
    twitter: 'https://x.com/PAULVANDYK',
    spotify: 'https://open.spotify.com/artist/7wU1naftD3lNq7rNsiDvOR',
    deezer: 'https://www.deezer.com/mx/artist/4730',
    apple: 'https://music.apple.com/mx/artist/paul-van-dyk/6505474',
    soundcloud: 'https://soundcloud.com/paulvandykofficial',
    tidal: 'https://listen.tidal.com/artist/57369',
    wiki: 'https://es.wikipedia.org/wiki/Paul_van_Dyk',
    ticketmaster:
      'https://www.ticketmaster.com/paul-van-dyk-tickets/artist/807130',
    napster: 'https://music.amazon.com.mx/artists/B000SZ2046/paul-van-dyk',
    tiktok: 'https://www.tiktok.com/@paulvandyk',
  },
  {
    title: 'Danny Tenaglia',
    description:
      'Danny Tenaglia (nacido en New York, el 7 de marzo de 1961), es un Dj, productor musical y remezclador estadounidense de música house y techno.Es uno de los pionieros de la escena house americana con mezclas progresivas, techno y Tribal house.En un principio, era conocido como Disc Jockey en el Paradise Garage en Nueva York. Fue famoso por la creación de "marathon set" que duró 20 horas sin parar.En 2002, recibió una nominación a los premios Grammy por su remix de I Feel Loved para Depeche Mode en la categoría “Mejor Grabación Remixada”, también fue nominada como Mejor Canción Dance. En 2021, con motivo de su 60 cumpleaños, la plataforma de distribución y venta de música Beatport organizó un festival en streaming con grandes artistas para rendirle homenaje como son: Benny Soto & Mike Nervous, Sasha Carassi, Harry Romero, Sharam, KiNK, Blond:ish, Markus Schulz, Seth Troxler, el propio Danny Tenaglia, Carl Cox, Chris Liebing, Ilario Alicante, Steve Lawler, Hernan Cattaneo, DJ Chus, Demi, Mendo, Lauren Lane, Behrouz, Misstress Barbara, Boris, Pablo Ceballos, DJ Vibe, Guy Gerber, David Guetta, Nicole Moudaber, Dubfire, Paco Osuna y Victor Calderone.',
    videourl:'https://youtube.com/playlist?list=UULF7I37IXlzlMwCMrEQnp3GXw&si=VWvMKLVBxyw0f-_I',
    price: '$50',
    coverImg: 'dannytenaglia.jpg',
    category: 'Electronica',
    location: 'USA',
    locationImg: 'usaflag.jpg',
    openSpots: null,
    likes: null,
    websiteurl: 'https://dannytenaglia.com/',
    youtube: 'https://www.youtube.com/@DannyTenagliaDotCom',
    facebook: 'https://www.facebook.com/DannyTenaglia/',
    instagram: 'https://www.instagram.com/dannytenagliaofficial/',
    twitter: 'https://x.com/dannytenagliadj',
    spotify: 'https://open.spotify.com/artist/2tG935baRE4mH8B3saiwbm',
    deezer: 'https://www.deezer.com/mx/artist/66209',
    apple: 'https://music.apple.com/mx/artist/danny-tenaglia/1008754',
    soundcloud: 'https://soundcloud.com/danny-tenaglia-official',
    tidal: 'https://listen.tidal.com/artist/19953',
    wiki: 'https://es.wikipedia.org/wiki/Danny_Tenaglia',
    ticketmaster:
      'https://www.ticketmaster.com/danny-tenaglia-tickets/artist/967912',
    napster: 'https://music.amazon.com.mx/artists/B000SA3DKQ/danny-tenaglia',
    tiktok: 'https://www.tiktok.com/@dannytenagliadj',
  },
  {
    title: 'Paul Oakenfold',
    description:
      "Paul Mark Oakenfold (Mile End, Londres, Inglaterra, Reino Unido; 30 de agosto de 1963), anteriormente conocido también como Oakenfold, es un productor de música electrónica y es uno de los DJ más reconocidos del mundo.Paul Oakenfold es probablemente el más reconocido productor y DJ que ha emergido de la escena musical Inglesa en los últimos diez años.Sus principales influencias fueron el rock progresivo y la música disco en los setenta, una combinación impensable en su época pero que lentamente fue cristalizando en la escena del rave en Mánchester a mediados de los ochenta. Fue ahí en la Haçienda de Tony Wilson donde al ritmo del Blue Monday de New Order, Oakenfold empezó a trabajar como DJ, ingeniero de sonido y hasta roadie para las bandas que tocaban ahí incluyendo a las futuras luminarias de The Stone Roses, The Charlatans y los emblemáticos Happy Mondays.Estas experiencias lo condujeron a la producción del último álbum de los Happy Mondays. La grabación en Ibiza del Pills 'n' Thrills and Bellyaches marcó no solo el momento en el que el house inglés se fusionaba con el rock para crear la prototípica música rave sino también la emergencia de una cultura basada por y alrededor del dance.Como ocurre frecuentemente, el momento de mayor gloria también marcaría la decadencia de este efímero género que cambió para siempre la forma en la que miles de personas experimentaban la música a finales de los ochenta.Después de la disolución de los Happy Mondays, la clausura definitiva de la Haçienda y la debacle financiera de Rough Trade Records parecía que el sueño de hermanar el rock con la música de baile terminaba para siempre.Paul Oakenfold reaccionó a estos cambios buscando un sonido más refinado y expresivo y fue así como terminó mezclando en el Cream, un entonces poco conocido antro en Liverpool. Ahí, en el lugar más insospechado de Inglaterra, se iniciaría el renacimiento de la escena rave. En 1989 fundó su discográfica Perfecto Records. El sello se distribuyó a través de Warner Music durante la década de 1990, hasta que Paul Oakenfold trasladó la distribución a Mushroom UK en 1998. Después de la adquisición por parte de Warner Music de Mushroom UK, el catálogo de Perfecto desde 1998 pasó a Warner Music y un par de años después Perfecto comenzó a operar y lanzar de forma independiente hasta que se convirtió en un subsello de Armada Music en 2010.",
    videourl:
      'https://www.youtube.com/playlist?list=UULP3J9EIm0n-NU1RBPlsWIT7g',
    price: 80,
    coverImg: 'pauloakenfold.jpg',
    category: 'Electronica',
    location: 'England',
    locationImg: 'england.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://www.pauloakenfold.com/',
    youtube: 'https://www.youtube.com/@pauloakenfold',
    facebook: 'https://www.facebook.com/Oakenfold',
    instagram: 'https://www.instagram.com/pauloakenfold',
    twitter: 'https://x.com/pauloakenfold',
    spotify: 'https://open.spotify.com/artist/5MO2kbaGGA2a8kL4c9qqHq',
    deezer: 'https://www.deezer.com/mx/artist/607',
    apple: 'https://music.apple.com/mx/artist/paul-oakenfold/1249423',
    soundcloud: 'https://soundcloud.com/pauloakenfold',
    tidal: 'https://listen.tidal.com/artist/9270',
    wiki: 'https://es.wikipedia.org/wiki/Paul_Oakenfold',
    ticketmaster:
      'https://www.ticketmaster.com/paul-oakenfold-tickets/artist/806648',
    tiktok: 'https://www.tiktok.com/@paul.oakenfold?lang=es',
    napster: 'https://music.amazon.com.mx/artists/B000QJPMQ2/paul-oakenfold',
  },
  {
    title: 'Dennis Gold',
    description:
      "Dennis Gold es un productor musical y DJ croata multi-platino, actualmente radicado en Bangkok, Tailandia. Su carrera comenzó en 2012, perfeccionando su arte mediante la creación de ritmos e instrumentales, hasta lograr créditos de producción y composición en más de 300 canciones de diversos géneros.Con una mezcla única de música electrónica, ritmos afro y influencias orientales, su sonido ha evolucionado en una fusión global que ha cautivado a audiencias de todo el mundo.Reconocido por su creatividad y su búsqueda incansable de nuevos horizontes sonoros, Dennis Gold no solo demuestra su destreza técnica en el escenario y en el estudio, sino también su profunda pasión por la innovación musical. Siempre explorando y reinventándose, sigue desafiando los límites mientras se mantiene fiel a sus raíces.",
    videourl:
      'https://youtube.com/playlist?list=PLfhvk20FMcJ8-xwfn66nkozOGoTc_B_zY&si=RkNS8QnhkHfIKnPp',
    price: 80,
    coverImg: 'dennisgold.png',
    category: 'Electronica',
    location: 'Croatia',
    locationImg: 'croatia.jpeg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://dennisgold.komi.io/',
    youtube: 'https://www.youtube.com/channel/UC1o03QaaYWj98djQMbswJmA',
    facebook: 'https://www.facebook.com/dennis.gold.33',
    instagram: 'https://www.instagram.com/dennisgoldmusic/',
    spotify: 'https://open.spotify.com/artist/47J6Id8OV765OFL0yvoJDq',
  },
 
  {
    title: 'Carl Cox',
    description:
      "Carl Cox (born 29 July 1962) is a British house and techno club DJ, radio DJ and record producer. He is based in Frankston, Victoria, Australia. Cox has won and been nominated for numerous awards. He has performed at numerous clubs and electronic music or dance events worldwide. He has hosted a residency known as Music is Revolution every summer season at the Space Ibiza nightclub, from 2001 to 2016. He has featured his own Carl Cox & Friends stage at many festivals, such as Ultra Music Festival, The BPM Festival and Tomorrowland. Cox has also served as a monthly DJ for BBC Radio 1's Essential Mix.He runs the record label, Intec Digital, which was founded around 1998 as Intec Records. Cox also had his own radio show and podcast, entitled Global, which he ran until February 2017. In 2018, he founded Awesome Soundwave, a record label focused on live electronic music artists, with live artist and producer Christopher Coe",
    videourl:
      'https://youtube.com/playlist?list=OLAK5uy_nnPZbJTW16PKNdverro2SdP1gQs8zwG0w&si=XQXun8_NV44dHzrC',
    price: 80,
    coverImg: 'carlcox.jpg',
    category: 'Electronica',
    location: 'UK',
    locationImg: 'england.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://carlcox.com/',
    youtube: 'https://www.youtube.com/channel/UCCrHGOX6Uoj5PndNIoRkoFw',
    facebook: 'https://www.facebook.com/carlcox247/',
    instagram: 'https://www.instagram.com/carlcoxofficial',
    twitter: 'https://x.com/Carl_Cox',
    spotify: 'https://open.spotify.com/artist/19SmlbABtI4bXz864MLqOS',
    deezer: 'https://www.deezer.com/mx/artist/3951',
    apple: 'https://music.apple.com/mx/artist/carl-cox/2811492',
    soundcloud: 'https://soundcloud.com/carl-cox',
    tidal: 'https://listen.tidal.com/artist/3581673',
    wiki: 'https://en.wikipedia.org/wiki/Carl_Cox',
    ticketmaster:
      'https://www.ticketmaster.com/carl-cox-tickets/artist/806867',
    tiktok: 'https://www.tiktok.com/@carlcox?lang=es',
    napster: 'https://music.amazon.com.mx/artists/B000T19KME/carl-cox',
  },
  {
    title: 'Richie Hawtin',
    description:
      "Richie Hawtin (de nacimiento Richard Michael Hawtin) es un DJ, músico y productor británico, naturalizado canadiense. Reside actualmente en Berlín.​ Está considerado como uno de los máximos exponentes de la música electrónica.Figura entre los artistas de música electrónica más conocidos del mundo,​ gracias a una carrera de más de 30 años. Activo en la escena techno y acid norteamericana desde sus comienzos, ha evolucionado hacia un estilo más minimalista y experimental, privilegiando el uso de las últimas tecnologías de composición y de DJing.Aunque ha producido a menudo bajo su nombre real, utiliza también numerosos pseudónimos, entre los cuales el más conocido es Plastikman. Es el fundador y dueño de los sellos discográficos Plus 8 y Minus, desde los cuales ha publicado sus álbumes más significativos, destacando entre ellos el disco Consumed, publicado en 1998, y la serie de álbumes mezclados DE9, de entre los cuales el más famoso es DE9 | Closer to the Edit, publicado en 2001.Más allá de sus actividades como músico, dedica también parte de su tiempo a sus negocios y al arte moderno.Desde 2012, lleva a cabo su evento experimental ENTER., en la discoteca Space en Ibiza.",
    videourl:
      'https://www.youtube.com/playlist?list=UULP2tkpbU5ELaFXI2Bn2WnaJg',
    price: 80,
    coverImg: 'richiehawtin.jpg',
    category: 'Electronica',
    location: 'England',
    locationImg: 'britishcanadian.png',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://plastikman.com/',
    youtube: 'https://www.youtube.com/@richiehawtin',
    facebook: 'https://www.facebook.com/richiehawtin',
    instagram: 'https://www.instagram.com/richiehawtin',
    twitter: 'https://x.com/richiehawtin',
    spotify: 'https://open.spotify.com/artist/3AhwIUus3pIaA3CvYBEtpy',
    deezer: 'https://www.deezer.com/mx/artist/498301',
    apple: 'https://music.apple.com/mx/artist/richie-hawtin/4090861',
    soundcloud: 'https://soundcloud.com/richiehawtin',
    tidal: 'https://listen.tidal.com/artist/3837153',
    wiki: 'https://es.wikipedia.org/wiki/Richie_Hawtin',
    ticketmaster:
      'https://www.ticketmaster.com/richie-hawtin-tickets/artist/806839',
    tiktok: 'https://www.tiktok.com/@richiehawtinofficial',
    napster: 'https://music.amazon.com.mx/artists/B000Y099BC/richie-hawtin',
  },
  {
    title: 'Armand Van Helden',
    description:
      "Armand van Helden (Boston, Massachusetts, 16 de febrero de 1970) es un disc jockey y productor estadounidense de música house y electro. Fue unos de los principales propulsores del género speed garage, remezclando a varios grandes artistas como Katy Perry, Daft Punk, Britney Spears, David Guetta, Bloc Party, Madonna, Janet Jackson, Juliet Roberts, KRS One o Sneaker Pimps entre otros con este estilo musical. Está muy ligado a la escena electrónica neoyorkina.Suele remezclar y utilizar samples de funk, soul, rhythm & blues y rap propios de la escuela de finales de los 80 y principios de los 90, a los que hace homenaje en su éxito «I Want Your Soul». También ha utiliza filtros y progresiones de dub, como en su tema NYC beat, y samples de dancehall y reagge.Sus mayores grandes éxitos han sido el remix de la canción «Professional Widow» de Tori Amos, «My My My» (que contiene un sample de «Comin Apart» de Gary Wright) , y también «U Don't Know Me», que es obra propia de Van Helden. Otros dj's de renombre de subgéneros como el nu skool break o el jungle han remezclado varias de sus canciones.",
    videourl:
      'https://youtube.com/playlist?list=OLAK5uy_n_qpS3oUFCFhTGCQu6kdbXEWoBIIz9yuE&si=VRiGjsNq2Wu-AXov',
    price: 80,
    coverImg: 'armandvanhelden.jpg',
    category: 'Electronica',
    location: 'USA',
    locationImg: 'usaflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://www.armandvanhelden.com/',
    youtube: 'https://www.youtube.com/channel/UC6BVhAbgFWg2gsjABdBFbFw',
    facebook: 'https://www.facebook.com/armandvanhelden',
    instagram: 'https://www.instagram.com/armandvanhelden/',
    twitter: 'https://x.com/Lord_Helden',
    spotify: 'https://open.spotify.com/artist/3cQA9WH8liZfeja1DxcDYE',
    deezer: 'https://www.deezer.com/mx/artist/1079',
    apple: 'https://music.apple.com/mx/artist/armand-van-helden/7431216',
    soundcloud: 'https://soundcloud.com/armandvanhelden',
    tidal: 'https://listen.tidal.com/artist/6533',
    wiki: 'https://es.wikipedia.org/wiki/Armand_Van_Helden',
    ticketmaster:
      'https://www.ticketmaster.com/armand-van-helden-tickets/artist/955581',
    tiktok: 'https://www.tiktok.com/search/video?q=armand%20van%20helden&t=1726643508629',
    napster: 'https://music.amazon.com.mx/artists/B000QJIEZI/armand-van-helden',
  },
  {
    title: 'Skrillex🌶️🌶️🌶️',
    description:
      "Sonny John Moore (Los Ángeles, California; 15 de enero de 1988), conocido por su nombre artístico Skrillex, es un DJ, cantante, remezclador y productor discográfico estadounidense. Comenzó su carrera en 2004 como vocalista de la banda de post-hardcore From First To Last. Tras dejar el grupo en 2007 desarrolló su carrera en solitario adoptando un sonido inspirado en la música electrónica.Moore se crio en diferentes localidades de California y a principios de 2004 se mudó a Georgia para liderar la banda From First to Last, con la que grabó los álbumes Dear Diary, My Teen Angst Has a Body Count y Heroine antes de iniciar una carrera como solista en febrero de 2007.1​ Conocido simplemente como Sonny, participó en múltiples giras a nivel nacional tocando sus demos y en 2009 publicó el EP Gypsyhook.2​ Ese año adoptó el seudónimo Skrillex y su música pasó a tener un sonido inspirado en la música dance y el dubstep. Adquirió popularidad un año más tarde con Scary Monsters and Nice Sprites y en 2012 recibió cinco nominaciones a los Premios Grammy, incluida una al mejor artista nuevo. Su discografía ejerció un papel fundamental en la popularización de los géneros dubstep y brostep;3​ sus mayores éxitos incluyen temas como «Scary Monsters and Nice Sprites», «Bangarang», «First of the Year (Equinox)» y «Purple Lamborghini». Skrillex se convirtió en el músico dance más laureado en la historia de los Premios Grammy tras superar al dúo francés Daft Punk en 2013,5​ y actualmente cuenta con nueve premios y diecisiete nominaciones totales.6​ DJ Mag lo consideró como el noveno mejor pinchadiscos del mundo desde 2014 hasta 2016,7​ mientras que 1001Tracklists lo nombró como el mejor productor musical desde 2016 hasta 2017.8​ Además, se destacó como coproductor de artistas como Justin Bieber, Camila Cabello, Jennifer Lopez, The Weeknd y Mariah Carey,9​ y formó parte de los supergrupos Dog Blood (2012-presente) con Boys Noize,10​ y Jack Ü (2013-2016) con Diplo.11​ Con este último realizó el sencillo «Where A",
    videourl:
      'https://youtube.com/playlist?list=PL9Z0stL3aRyklTu0qGUErA5z7LB9esMo9&si=sJP9JN_3yyNX6z3h',
    price: 80,
    coverImg: 'skrillex.jpg',
    category: 'Electronica',
    location: 'USA',
    locationImg: 'usaflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://www.skrillex.com/fus',
    youtube: 'https://www.youtube.com/channel/UC_TVqp_SyG6j5hG-xVRy95A',
    facebook: 'https://www.facebook.com/skrillex',
    instagram: 'https://www.instagram.com/skrillex',
    twitter: 'https://x.com/skrillex',
    spotify: 'https://open.spotify.com/artist/5he5w2lnU9x7JFhnwcekXX',
    deezer: 'https://www.deezer.com/mx/artist/1079',
    apple: 'https://music.apple.com/mx/artist/skrillex/356545647',
    soundcloud: 'https://soundcloud.com/skrillex',
    tidal: 'https://listen.tidal.com/artist/6533',
    wiki: 'https://es.wikipedia.org/wiki/Skrillex',
    ticketmaster:
      'https://www.ticketmaster.com/skrillex-tickets/artist/1482845',
    tiktok: 'https://www.tiktok.com/@skrillex',
    napster: 'https://music.amazon.com.mx/artists/B003920VNW',
  },{
    title: 'Rüfüs Du Sol',
    description:
      "Rüfüs Du Sol, estilizado como RÜFÜS DU SOL y anteriormente conocido simplemente como Rüfüs (estilizado como RÜFÜS) de 2010 a 2018,1​2​ es un grupo de dance alternativo 3​ originario de Australia conformado por Tyrone Lindqvist, Jon George y James Hunt. Su álbum debut, Atlas, alcanzó el puesto número uno en Australia, mientras que su segundo álbum, Bloom, debutó en la cima de la lista de álbumes australianos a principios de 2016. Su sencillo «You Were Right» ganó el premio ARIA al Mejor Lanzamiento Dance en 2015. Si bien todavía se les conoce como Rüfüs en otros lugares, actuaron como Rüfüs Du Sol en los Estados Unidos porque Rufus ya estaba ocupado. En 2018 cambiaron su nombre a Rüfüs Du Sol a nivel internacional.",
    videourl:
      'https://youtube.com/playlist?list=PLycYa5iTh017uOxlUXbKtrQiusezsB8xH&si=PiFSonvMTqO4AtAC',
    price: 80,
    coverImg: 'rufus.jpg',
    category: 'Electronica',
    location: 'Australia',
    locationImg: 'australia.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://www.rufusdusol.com/live',
    youtube: 'https://www.youtube.com/channel/UC6iin46o7SrAsnl9ig__vlw',
    facebook: 'https://www.facebook.com/rufusdusol',
    instagram: 'https://www.instagram.com/rufusdusol/?hl=en',
    twitter: 'https://x.com/rufusdusol?lang=en',
    spotify: 'https://open.spotify.com/artist/5Pb27ujIyYb33zBqVysBkj?autoplay=true',
    deezer: 'https://www.deezer.com/us/artist/5571502',
    apple: 'https://music.apple.com/mx/artist/r%C3%BCf%C3%BCs-du-sol/799587823',
    soundcloud: 'https://soundcloud.com/rufusdusol',
    wiki: 'https://en.wikipedia.org/wiki/R%C3%BCf%C3%BCs_Du_Sol',
    ticketmaster:
      'https://www.ticketmaster.com.mx/rufus-du-sol-inhale-exhale-world-zapopan-12-03-2025/event/3D006143BB2C3AC5?',
    tiktok: 'https://www.tiktok.com/@rufusdusol?lang=en',

  },{
    title: 'Matroda',
    description:
      "Matroda, productor criado en Croacia, es el epítome de la fugaz existencia de la música electrónica. Acogiendo la música house a su manera, con el acertado nombre de «matrodasound» acuñado por sus verdaderos fans, el estudio no pone límites a este artista único pero increíblemente célebre.",
    videourl:
      'https://youtube.com/playlist?list=PLEKOYadEm53RiWRTFp5IPS0isgDmLLc39&si=vFIumtMYIuKjtEHi',
    price: 80,
    coverImg: 'matroda.jpg',
    category: 'Electronica',
    location: 'Croatia',
    locationImg: 'croatia.jpeg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://matrodamusic.com/',
    youtube: 'https://www.youtube.com/channel/UCwe-ITb2csyXTuB-l2Cf9MA',
    facebook: 'https://www.facebook.com/matrodamusic?',
    instagram: 'https://www.instagram.com/matrodamusic/?hl=en',
    twitter: 'https://x.com/matrodamusic?lang=en',
    spotify: 'https://open.spotify.com/artist/45lcbTsX07JWzmTIjcdyBz',
    deezer: 'https://www.deezer.com/mx/artist/54836349',
    apple: 'https://music.apple.com/us/artist/matroda/488606990?l=es-MX',
    soundcloud: 'https://soundcloud.com/matrodamusic',
    wiki: 'https://es.wikipedia.org/wiki/Skrillex',
    ticketmaster:
      'https://www.ticketmaster.com/matroda-tickets/artist/2461046',
    tiktok: 'https://www.tiktok.com/@matrodamusic',

  },
  {
    title: 'Dom Dolla',
    description:
      "Dominic Louis Matheson, conocido artísticamente como Dom Dolla, es un productor de música house, DJ, compositor y remezclador australiano, reconocido por su estilo distintivo y colaboraciones de alto perfil. Nació el 18 de enero de 1992 en Manila, Filipinas, y creció en Darwin, Territorio del Norte, Australia. Durante su adolescencia, se mudó a Melbourne, donde descubrió la música house y electrónica. A lo largo de su carrera, Dom Dolla ha sido nominado en ocho ocasiones al ARIA Award a la Mejor Producción Dance. En 2017, fue nominado por Be Rand  en colaboración con Torren Foot, y en 2019 por la canción Take It. Ganó el premio en los ARIA Music Awards de 2020 por San Frandisc  y nuevamente en 2023 por Rhyme Dus  junto a MK. En 2024, fue nominado al Grammy por la canción New Gol , en colaboración con Gorillaz, Tame Impala y Bootie Brown, y al Juno Award por Eat Your Ma  con Nelly Furtado. Ha actuado en festivales de renombre como Coachella en 2022 y Lollapalooza en 2023. Además, ha agotado entradas en lugares emblemáticos como el Red Rocks Amphitheatre en Denver, Colorado, el Sidney Myer Music Bowl en Melbourne, Australia, y el Forest Hills Stadium en Nueva York. Dom Dolla ha experimentado un ascenso meteórico, conectando con audiencias globales y siendo reconocido como uno de los productores más emocionantes en la música electrónica. Su estilo característico de música house ha resonado en todo el mundo, consolidando su posición en la industria.",
    videourl:
      'https://youtube.com/playlist?list=PL3YL_0wKTB1d_AE5WPD5vGq-1tHWMJltV&si=hwnfpHheX6WhHW5P',
    price: 80,
    coverImg: 'domdolla.jpg',
    category: 'Electronica',
    location: 'Filipinas',
    locationImg: 'Philipinnes.png',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://www.domdolla.com/',
    youtube: 'https://www.youtube.com/channel/UCWVBfvVTf3UrPA-z5gos60w',
    facebook: 'https://www.facebook.com/domdollamusic/',
    instagram: 'https://www.instagram.com/domdolla/?',
    twitter: 'https://x.com/domdolla',
    spotify: 'https://open.spotify.com/artist/205i7E8fNVfojowcQSfK9m?si=5R0RnD_5Rd2k27K4mL5xFQ&nd=1&dlsi=a6e1b3ec03404037',
    deezer: 'https://www.deezer.com/mx/artist/4740325',
    apple: 'https://music.apple.com/au/artist/dom-dolla/555348065',
    wiki: 'https://en.wikipedia.org/wiki/Dom_Dolla',
    ticketmaster:
      'https://www.ticketmaster.com.mx/search?q=Dom+Dolla',
    tiktok: 'https://www.tiktok.com/@domdolla?lang=en',
  },
  {
    title: 'Hugel',
    description:
      "Florent Hugel, nacido el 4 de diciembre de 1987 en Marsella, Francia, es un DJ, productor musical y remezclador francés conocido profesionalmente como HUGEL.Ganó notoriedad en 2018 con su remix de Bella Ciao, que se convirtió en un éxito viral. En 2021, lanzó Morenita, una canción que ayudó a popularizar el género Latin House.A lo largo de su carrera, HUGEL ha colaborado con artistas de renombre como David Guetta, Robin Schulz y J Balvin, y ha realizado remixes para muchos de ellos. En 2024, alcanzó la fama internacional con su exitoso sencillo I Adore You.Comenzó su carrera como DJ a los 16 años en Marsella, influenciado por artistas como Daft Punk, Carl Cox y Laurent Garnier. Ha actuado en festivales de gran prestigio como Tomorrowland, EDC Las Vegas y Lollapalooza, además de haber tenido residencias en famosos clubes de Ibiza como Ushuaïa y Pacha.En 2024, amplió su contrato de publicación con BMG, consolidando su influencia en la escena de la música electrónica.Entre sus producciones más destacadas se encuentran remixes como Mi Gente (2017) y temas originales como I Believe I'm Fine (2017) y Morenita(2021). Su éxito más reciente, I Adore You (2024), ha reafirmado su posición en la industria.",
    videourl:
      'https://youtube.com/playlist?list=PLhkalhfnM0ylCoVlspCJLGDXfPkjnowV1&si=M2Pz_ZqPIdsLgZH1',
    price: 80,
    coverImg: 'hugel.jpg',
    category: 'Electronica',
    location: 'France',
    locationImg: 'France.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://www.insomniac.com/music/artists/hugel/',
    youtube: 'https://www.youtube.com/channel/UCWVBfvVTf3UrPA-z5gos60w',
    facebook: 'https://www.facebook.com/hugelmusic',
    instagram: 'https://www.instagram.com/hugelthug/',
    twitter: 'https://x.com/hugelthug?lang=en',
    spotify: 'https://open.spotify.com/artist/5PlfkPxwCpRRWQJBxCa0By',
    deezer: 'https://www.deezer.com/mx/artist/54836349',
    apple: 'https://music.apple.com/es/artist/hugel/978839124',
    soundcloud: 'https://soundcloud.com/HUGELMUSIC',
    wiki: 'https://en.wikipedia.org/wiki/Hugel_(DJ)',
    ticketmaster:
      'https://www.ticketmaster.com.mx/hugel-boletos/artist/2625348',
    tiktok: 'https://www.tiktok.com/@hugelthug?lang=en',
  },
  {
    title: 'Bad Boy Bill',
    description:
      "Bad Boy Bill (nacido como William Renkosik) es un disc jockey (DJ) de Chicago, Illinois, EE. UU., que toca una variedad de música house. Apenas en su adolescencia, Bad Boy Bill comenzó su carrera como DJ en 1985 durante el movimiento de la música house en Chicago a mediados y finales de la década de 1980.Trabajó con Mike Hitman Wilson y Julian Jumpin Perez del equipo de mezcla de DJs de WBMX, conocido en ese entonces como los Hot Mix 5. La popularidad de Bill creció al pinchar en fiestas por toda el área metropolitana de Chicago, además de abrir para los Hot Mix 5. Bad Boy Bill fue un DJ habitual en las populares mezclas de house en WBMX 102.7 FM en Chicago, WGCI 107.5 FM y luego en B96 96.3 FM, una estación de música pop.Como remezclador, logró su primer éxito en el Top Five de la lista Billboard Dance Chart a los 19 años con Deep Love de Dada Nada, que también contó con remezclas de las leyendas de la música house Frankie Knuckles y David Morales, Robert Ozn y Steve Wight.Actualmente, Bad Boy Bill toca música que va desde House hasta Electro y es conocido por tocar en seis tornamesas separadas al mismo tiempo. En 1988 y 1989, se ubicó entre los tres primeros en los campeonatos de Disco Mix Club.Bad Boy Bill también hizo una aparición no acreditada como el DJ del club en la escena de apertura de la película Blade de 1998.",
    videourl:
      'https://youtube.com/playlist?list=PLFvH_4Bu2BSoYmbASVDdx5k_n5bwtgKFU&si=EHy8mIR36eD9yMQX',
    price: 80,
    coverImg: 'badboybill.jpg',
    category: 'Electronica',
    location: 'USA',
    locationImg: 'usaflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://badboybill.com/',
    youtube: 'https://www.youtube.com/@DJbadboybill',
    facebook: 'https://www.facebook.com/BadBoyBill',
    instagram: 'https://www.instagram.com/djbadboybill/',
    twitter: 'https://x.com/djbadboybill',
    spotify: 'https://open.spotify.com/artist/2GYDdjFOEdHrdLh50r5iFQ',
    deezer: 'https://www.deezer.com/mx/artist/7611',
    apple: 'https://music.apple.com/mx/artist/bad-boy-bill/79930509',
    soundcloud: 'https://soundcloud.com/djbadboybill',
    tidal: 'https://listen.tidal.com/artist/3598423',
    wiki: 'https://en.wikipedia.org/wiki/Bad_Boy_Bill',
    ticketmaster:
      'https://www.ticketmaster.com/bad-boy-bill-tickets/artist/806294',
    tiktok: 'https://www.tiktok.com/@djbadboybill',
    napster: 'https://music.amazon.com.mx/artists/B000QKJL68/bad-boy-bill',
  },
  {
    title: 'Martin Garrix',
    description:
      "Martijn Gerard Garritsen (Dutch: [mɑrˈtɛin ɣəˈrɑrt ˈxɑrɪtsə(n)] born 14 May 1996), known professionally as Martin Garrix and also as Ytram and GRX, is a Dutch disc jockey and music producer who was ranked number one on DJ Mag's Top 100 DJs list for three consecutive years—2016, 2017, and 2018. He is best known for his singles Animals, In the Name of Love and Scared to Be Lonely.",
    videourl:
      'https://youtube.com/playlist?list=PLOPmDfV0hAMYEgC2D6CJ7MkWswclPohRj',
    price: 80,
    coverImg: 'martingarrix.jpg',
    category: 'Electronica',
    location: 'Netherlands',
    locationImg: 'Netherlands.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://martingarrix.com/',
    youtube: 'https://www.youtube.com/channel/UC5H_KXkPbEsGs0tFt8R35mA',
    facebook: 'https://www.facebook.com/martin.garrix/',
    instagram: 'https://www.instagram.com/martingarrix/',
    twitter: 'https://twitter.com/MartinGarrix',
    spotify: 'https://open.spotify.com/artist/60d24wfXkVzDSfLS6hyCjZ',
    deezer: 'https://www.deezer.com/mx/artist/3968561',
    apple: 'https://music.apple.com/mx/artist/martin-garrix/430932944',
    soundcloud: 'https://soundcloud.com/martingarrix',
    tidal: 'https://listen.tidal.com/artist/4715335',
    wiki: 'https://en.wikipedia.org/wiki/Martin_Garrix',
    ticketmaster:
      'https://www.ticketmaster.com/martin-garrix-tickets/artist/1923024',
    tiktok: 'https://www.tiktok.com/@martingarrix?lang=es',
    napster: 'https://music.amazon.com.mx/artists/B004VJJSHW/martin-garrix',
  },
  {
    title: 'Fatboy Slim',
    description:
      "Norman Quentin Cook (nacido como Quentin Leo Cook; Bromley, Londres, 31 de julio de 1963), más conocido como Fatboy Slim, es un DJ y productor británico. Junto con otras bandas como The Prodigy y The Chemical Brothers,​ fue pionero en el género big beat, el cual es una combinación de hip hop, breakbeat, rock y rhythm and blues.La carrera musical de Norman cuenta con su participación en un grupo de rock llamado The Housemartins.​ En 1992 fundó Freak Power, un grupo musical de Brighton que publicó dos discos, consiguiendo que uno de sus temas apareciera en un anuncio de pantalones Levi's.En 1996 Norman Cook adoptó el nombre de «Fatboy Slim» y dio el salto internacional a las cabinas de DJ en colaboración con el productor Simon Thorton y el sello al que sigue vinculado, Skint Records, consiguiendo que sus creaciones le convirtieran en uno de los grandes del género big beat.Adoptó infinidad de alias y estilos: Pizzaman, Mighty Dub Cat, Freak Power, entre otros. A cada uno se lo puede asociar fácilmente a un estilo en concreto y una época de su vida e incluso alguno de ellos siguen dando sus frutos hoy en día.Fue en 1997, después de conocer al dúo The Chemical Brothers, cuando Fatboy Slim apareció con su álbum debut, Better Living Through Chemistry.1​ El título no es ninguna casualidad, referente absoluto dentro de la historia del big beat. Su siguiente trabajo de estudio, You've Come a Long Way, Baby, es un nombre imprescindible a la hora de hablar de su carrera discográfica llena de éxitos. Su último álbum, Halfway Between the Gutter and the Stars, se aleja un poco más del big beat para recordar, como Norman dice, a los sonidos que siempre le han inspirado para crear",
    videourl:
      'https://youtube.com/playlist?list=PLSrfzLXjOv32hbVJa-70fCvJoA4RG77Ki&si=ykH1wVjwkGjWDx6R',
    price: 80,
    coverImg: 'fatboyslim.jpg',
    category: 'Electronica',
    location: 'England',
    locationImg: 'england.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://www.fatboyslim.net/',
    youtube: 'https://www.youtube.com/channel/UCCbP5cOWp9s75x_r6xq7LcQ',
    facebook: 'https://www.facebook.com/fatboyslim',
    instagram: 'https://www.instagram.com/officialfatboyslim',
    twitter: 'https://x.com/FatboySlim',
    spotify: 'https://open.spotify.com/artist/4Y7tXHSEejGu1vQ9bwDdXW',
    deezer: 'https://www.deezer.com/mx/artist/76',
    apple: 'https://music.apple.com/mx/artist/fatboy-slim/1093405',
    soundcloud: 'https://soundcloud.com/pauloakenfold',
    tidal: 'https://listen.tidal.com/artist/782',
    wiki: 'https://es.wikipedia.org/wiki/Fatboy_Slim',
    ticketmaster:
      'https://www.ticketmaster.com/fatboy-slim-tickets/artist/806786',
    tiktok: 'https://www.tiktok.com/@fatboyslimofficial?lang=es',
    napster: 'https://music.amazon.com.mx/artists/B000QJTDM6/fatboy-slim',
  },
  {
    title: 'Route 94',
    description:
      "Rowan Tyler Jones (nacido el 21 de mayo de 1993), conocido por su nombre artístico Route 94, es un productor y remezclador inglés originario de Richmond, Londres. Inicialmente produciendo dubstep bajo el nombre de Dream, Jones colaboró con artistas como Skream, Benga y Katy B. Posteriormente, comenzó a producir música house. Su sencillo My Love fue un éxito comercial, alcanzando el número uno en tres listas de éxitos.",
    videourl:
      'https://youtube.com/playlist?list=OLAK5uy_nki6gG8EU8cuI14_44rzZc5V3thZ_5NEg&si=s9YZqTsilEDvxqZ4',
    price: 80,
    coverImg: 'route94.jpg',
    category: 'Electronica',
    location: 'England',
    locationImg: 'england.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://route94.com/',
    youtube: 'https://www.youtube.com/channel/UCg6sxFhxjLz8Xp2ZKzbLCWQ',
    facebook: 'https://www.facebook.com/route94',
    instagram: 'https://www.instagram.com/route94/',
    twitter: 'https://x.com/route_94',
    spotify: 'https://open.spotify.com/artist/1dgdvbogmctybPrGEcnYf6',
    deezer: 'https://www.deezer.com/mx/artist/251450062',
    apple: 'https://music.apple.com/gb/artist/route-94/650435297',
    soundcloud: 'https://soundcloud.com/route94',
    tidal: 'https://listen.tidal.com/artist/4928123',
    wiki: 'https://en.wikipedia.org/wiki/Route_94_(musician)',
    ticketmaster:
      'https://www.ticketmaster.com/route-94-tickets/artist/1974233',
    tiktok: 'https://www.tiktok.com/@route94music?lang=es',
    napster: 'https://music.amazon.com/artists/B00CVO38O8/route-94',
  },
  {
    title: 'Calvin Harris',
    description:
      'Adam Richard Wiles (Dumfries, Dumfries y Galloway, 17 de enero de 1984), más conocido como Calvin Harris, es un DJ, cantante y productor británico. Actualmente ocupa el puesto 16 de los 100 mejores DJ de la revista DJ Magazine. Su álbum debut, seleccionado por la Industria Fonográfica Británica, I Created Disco, fue lanzado en 2007 y contenía sencillos tales como Acceptable in the 80s y The Girls que ingresaron en el Top 10 del Reino Unido.',
    videourl:
      'https://youtube.com/playlist?list=PLCnkz7la5RxMxu9cbTxpXhYrwWDrweJVA',
    price: '$50',
    coverImg: 'calvinharris.jpg',
    category: 'Electronica',
    location: 'UK',
    locationImg: 'england.jpg',
    openSpots: null,
    likes: null,
    websiteurl: 'https://loveregenerator.com/',
    youtube: 'https://www.youtube.com/channel/UCIjYyZxkFucP_W-tmXg_9Ow',
    facebook: 'https://www.facebook.com/search/top?q=calvin%20harris',
    instagram: 'https://www.instagram.com/calvinharris/',
    twitter: 'https://twitter.com/CalvinHarris',
    spotify: 'https://open.spotify.com/artist/7CajNmpbOovFoOoasH2HaY',
    deezer: 'https://www.deezer.com/mx/artist/5313805',
    apple: 'https://music.apple.com/mx/artist/calvin-harris/201955086',
    soundcloud: 'https://soundcloud.com/calvinharris',
    tidal: 'https://listen.tidal.com/artist/8401',
    wiki: 'https://es.wikipedia.org/wiki/Calvin_Harris',
    ticketmaster:
      'https://www.ticketmaster.com/calvin-harris-tickets/artist/1149552',
    napster: 'https://music.amazon.com.mx/artists/B000YC5H4S/calvin-harris',
    tiktok: 'https://www.tiktok.com/@calvinharris?lang=es',
  },
  {
    title: 'Hernan Cattaneo',
    description:
      'Hernán Cattáneo es un destacado DJ y productor musical argentino, reconocido internacionalmente por su influencia en la música electrónica, especialmente en los géneros de progressive house y deep house. Nacido el 4 de diciembre de 1966 en Buenos Aires, Cattáneo comenzó su carrera en la década de 1980 y ha evolucionado a lo largo de los años, ganando reconocimiento por su estilo distintivo y su habilidad para crear atmósferas envolventes en sus sets.A lo largo de su carrera, ha actuado en importantes festivales y clubes de todo el mundo, incluyendo eventos como el Ultra Music Festival y Tomorrowland. También ha lanzado varias compilaciones de mezclas y álbumes originales, consolidando su reputación como uno de los mejores DJs de América Latina.Además de su carrera como DJ, Hernán Cattáneo ha sido un pionero en la escena electrónica en Argentina, contribuyendo al desarrollo de la cultura del club y promoviendo nuevos talentos. Su pasión por la música y su dedicación a su arte lo han llevado a recibir numerosos premios y reconocimientos en la industria musical. Cattáneo continúa siendo una figura influyente en la música electrónica, atrayendo a seguidores de todo el mundo con su estilo único y su compromiso con la innovación musical.',
    videourl:
      'https://youtube.com/playlist?list=OLAK5uy_kISE8nGz6AHVtjIqAWXG-odPewl5tfWwk&si=yaNYaME5-YvItRgy',
    price: '$50',
    coverImg: 'hernancattaneo.jpg',
    category: 'Electronica',
    location: 'Argentina',
    locationImg: 'argentinaflag.jpg',
    openSpots: null,
    likes: null,
    websiteurl: 'https://www.hernancattaneo.com/',
    youtube: 'https://www.youtube.com/channel/UCtu51zQwrswrojbaoNtgWgw',
    facebook: 'https://www.facebook.com/hernancattaneo/',
    instagram: 'https://www.instagram.com/djhernancattaneo/',
    twitter: 'https://x.com/cattaneo_hernan/',
    spotify: 'https://open.spotify.com/artist/4mpJaw5y17CIN08qqe8EfB',
    deezer: 'https://www.deezer.com/mx/artist/259014',
    apple: 'https://music.apple.com/mx/artist/hern%C3%A1n-catt%C3%A1neo/44974489',
    soundcloud: 'https://soundcloud.com/hernancattaneofans',
    tidal: 'https://listen.tidal.com/artist/3575361',
    wiki: 'https://es.wikipedia.org/wiki/Hern%C3%A1n_Catt%C3%A1neo',
    ticketmaster:
      'https://www.ticketmaster.com/hernan-cattaneo-tickets/artist/981579',
    napster: 'https://music.amazon.com.mx/artists/B000S2H972/hernan-cattaneo',
    tiktok: 'https://www.tiktok.com/@hernan_cattaneo?lang=es',
  },
  {
    title: 'John Digweed',
    description:
      'Thomas John Digweed (born 1 January 1967) is a British DJ and record producer. DJ Magazine voted him the World No. 1 DJ in 2001. As well as achieving success as a solo act, he has collaborated with Sasha as Sasha & John Digweed, and with Nick Muir as Bedrock.',
    videourl:
      'https://youtube.com/playlist?list=OLAK5uy_nB2cVbdbq7VY3cnNpkGN9Fq7cPb9I8Gs4&si=m1mBmmStvqldQnhQ',
    price: '$50',
    coverImg: 'johndigweed.jpg',
    category: 'Electronica',
    location: 'UK',
    locationImg: 'england.jpg',
    openSpots: null,
    likes: null,
    websiteurl: 'https://ra.co/dj/digweed',
    youtube: 'https://www.youtube.com/user/bedrocktransitions',
    facebook: 'https://www.facebook.com/djjohndigweed/',
    instagram: 'https://www.instagram.com/djjohndigweed/',
    twitter: 'https://x.com/DJJohnDigweed',
    spotify: 'https://open.spotify.com/artist/3xnDktxhudJR2Wv3HZDQ9W',
    deezer: 'https://www.deezer.com/mx/artist/186545',
    apple: 'https://music.apple.com/mx/artist/john-digweed/91476876',
    soundcloud: 'https://soundcloud.com/john-digweed',
    tidal: 'https://listen.tidal.com/artist/3550418',
    wiki: 'https://en.wikipedia.org/wiki/John_Digweed',
    ticketmaster:
      'https://www.ticketmaster.com/john-digweed-tickets/artist/848086',
    napster: 'https://music.amazon.com.mx/artists/B000RSBSBU/john-digweed',
    tiktok: 'https://www.tiktok.com/search/video?lang=es&q=John%20Digweed&t=1726255499244',
  },
  {
    title: 'Sasha',
    description:
      'Alexander Paul Coe (Bangor, Gwynedd, Gales; 4 de septiembre de 1969), conocido artísticamente como Sasha, es un disc jockey y productor musical británico. Comenzó su carrera tocando música del género acid house a finales de 1980. En 1995 se asoció con su compañero, el DJ británico John Digweed en 1993, con quien ha hecho varias giras internacionales y la producción de una serie de álbumes de remezclas. Sasha ha producido varios sencillos y aparecido en las listas de sencillos en el Reino Unido y ha remezclado varias pistas para artistas como Madonna y The Chemical Brothers. Su remix de «Watching Cars Go By» del disc jockey Felix da Housecat le valió una nominación a los Grammy en 2004, en la categoría Mejor grabación remixada, no clásica. Las remezclas de Sasha y su producción a menudo se combinan con géneros de música electrónica, lo que hace difícil para los críticos de identificar su estilo musical.Después de alcanzar el éxito como productor y DJ, Sasha trabajó con jóvenes DJs y productores como Brian Transeau, James Zabiela y Hassan Jewel, influyo en sus estilos musicales y técnicas.',
    videourl:
      'https://youtube.com/playlist?list=OLAK5uy_lNhg8RR38--Lj9Eo3Ss2pgN41XPq2YN7A&si=oCSFWcbV1jan7JQm',
    price: '$50',
    coverImg: 'sasha.jpg',
    category: 'Electronic',
    location: 'UK',
    locationImg: 'england.jpg',
    openSpots: null,
    likes: null,
    websiteurl: 'http://www.djsasha.com/',
    youtube: 'https://www.youtube.com/channel/UCPUCfgNOtnatPmD3ts08NMg',
    facebook: 'https://www.facebook.com/sasha ',
    instagram: 'https://www.instagram.com/djsashaofficial/ ',
    twitter: 'https://x.com/sashaofficial',
    spotify: 'https://open.spotify.com/artist/02QYcz7JjwzKiKGHg53rZY?autoplay=true',
    deezer: 'https://www.deezer.com/mx/artist/10267328',
    apple: 'https://music.apple.com/mx/artist/sasha/414607074',
    soundcloud: 'https://soundcloud.com/sashaofficial',
    tidal: 'https://listen.tidal.com/artist/7723897',
    wiki: 'https://es.wikipedia.org/wiki/Sasha_(DJ)',
    ticketmaster:
      'https://www.ticketmaster.com/sasha-tickets/artist/834046',
    napster: 'https://music.amazon.com.mx/artists/B07NDJFGL5/sasha',
    tiktok: 'https://www.tiktok.com/@dj_sash_official?lang=en',
  },
  {
    title: 'Deep Nation',
    description:
      'Deep house (110~125 BPM) is a subgenre of house music that originated in the 1980s, initially fusing elements of Chicago house with the lush chords of 1980s jazz-funk and touches of soul music. Its origins are attributed to the early recordings of Larry Heard (aka Mr. Fingers), including his influential track Can You Feel It.',
    videourl: 'https://youtube.com/playlist?list=UULFDnRtxAQIT9FAkr0CuhREeQ',
    price: 80,
    coverImg: 'deepnation.png',
    category: 'Electronica',
    location: 'Australia',
    locationImg: 'australia.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://www.beatport.com/artist/deep-house-nation/479233',
    youtube: 'https://www.youtube.com/c/SoulMixtape_DeepFeelingsMix',
    facebook: 'https://www.facebook.com/DeepNation1',
    instagram: 'https://www.instagram.com/__deep_nation__/',
    twitter: 'https://twitter.com/deep_nation',
    spotify: 'https://open.spotify.com/user/deepnationrecords',
    deezer: 'https://www.deezer.com/mx/artist/7828068',
    apple: 'https://music.apple.com/mx/artist/house-nation/297391815',
    soundcloud: 'https://soundcloud.com/deepnationrecords',
    tidal: 'https://listen.tidal.com/artist/3950311',
    wiki: 'https://en.wikipedia.org/wiki/Deep_house',
    ticketmaster: 'https://www.ticketmaster.com/',
    tiktok: 'https://www.tiktok.com/@dopenationrecords?lang=es',
    napster: 'https://music.amazon.com.mx/artists/B005OUBYPG/deep-nation',
  },
  {
    title: 'Infected Mushroom',
    description:
      "Infected Mushroom is an Israeli musical duo formed in Haifa in 1996 by producers Erez Eisen and Amit Duvdevani.[1] They produce and perform psytrance, electronica, dream trance and psychedelic music. They are one of the best-selling groups in Israeli music history in terms of both domestic and international sales.They employ a variety of musical sources, including acoustic guitars and complex synthesized basses. Their compositions often contain changes of drum beat and tempo. Infected Mushroom's live shows feature vocals and analogue instruments in performances that are set against a multimedia backdrop..",
    videourl:
      'https://youtube.com/playlist?list=OLAK5uy_khzB7ZlDTCokqsjF0vSvgapWPUk10qNFI',
    price: 80,
    coverImg: 'infectedmushroom.jpg',
    category: 'Electronica',
    location: 'Israel',
    locationImg: 'israelflag.png',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://infected-mushroom.com/',
    youtube: 'https://www.youtube.com/channel/UCrbvoMC0zUvPL8vjswhLOSw',
    facebook: 'https://www.facebook.com/infectedmushroom',
    instagram: 'https://www.instagram.com/infectedmushroom/',
    twitter: 'https://twitter.com/infected',
    spotify: 'https://open.spotify.com/artist/6S2tas4z6DyIklBajDqJxI',
    deezer: 'https://www.deezer.com/mx/artist/1956',
    apple: 'https://music.apple.com/mx/artist/infected-mushroom/67994774',
    soundcloud: 'https://soundcloud.com/infectedmushroom',
    tidal: 'https://listen.tidal.com/artist/3633502',
    wiki: 'https://en.wikipedia.org/wiki/Infected_Mushroom',
    ticketmaster:
      'https://www.ticketmaster.com/infected-mushroom-tickets/artist/1274899',
    tiktok: 'https://www.tiktok.com/@infectedmushroomofficial?lang=es',
    napster: 'https://music.amazon.com.mx/artists/B000RRFLJG/infected-mushroom',
  },
  {
    title: 'The Chemical Brothers',
    description:
      'The Chemical Brothers are an English electronic music duo[1] formed by Tom Rowlands and Ed Simons in Manchester in 1989. They were pioneers (along with the Prodigy, Fatboy Slim, the Crystal Method, and other acts) in bringing the big beat genre to the forefront of pop culture. After attracting Virgin Records, the duo achieved further success with second album Dig Your Own Hole (1997), which topped the UK charts. In the UK, they have had six No. 1 albums and 13 top-20 singles, including two chart-toppers..',
    videourl:
      'https://youtube.com/playlist?list=OLAK5uy_mm98ULXax2Mi5BojzmnTLC7s2EEJP67FM',
    price: 80,
    coverImg: 'thechemicalbrothers.jpg',
    category: 'Electronica',
    location: 'UK',
    locationImg: 'england.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://www.thechemicalbrothers.com/',
    youtube: 'https://www.youtube.com/channel/UCvyAsTkXVoCQtFG-rGhwCKw',
    facebook: 'https://www.facebook.com/ChemicalBros',
    instagram:
      'https://www.instagram.com/thechemicalbrothers/?fbclid=IwAR1dDgpV6BaVhf1jb6O970kcp1cb4b9_9xf_cwXdLoWNoyhfa6zm8fSJcqQ',
    twitter:
      'https://twitter.com/chembros?fbclid=IwAR0xNEDJtWf9XpqF-UIrraxwD0svMbKnUQtp_ReZprEiw-zPD5aU8J9-_dk',
    spotify:
      'https://open.spotify.com/user/chembrosmusic?fbclid=IwAR1XtSqq-D6kAT-Y2_x04nOgyY5_9Rc6HHGWIedlX9SkJIhHFpQOyTLOEAU',
    deezer: 'https://www.deezer.com/mx/artist/81',
    apple: 'https://music.apple.com/mx/artist/the-chemical-brothers/3726283',
    soundcloud: 'https://soundcloud.com/thechemicalbrothers',
    tidal: 'https://listen.tidal.com/artist/9124',
    wiki: 'https://en.wikipedia.org/wiki/The_Chemical_Brothers',
    ticketmaster:
      'https://www.ticketmaster.com/chemical-brothers-tickets/artist/807212',
    tiktok: 'https://www.tiktok.com/@chemicalbrothersofficial',
    napster: 'https://music.amazon.com.mx/artists/B00G5XK5K6/the-chemical-brothers',
  },
  {
    title: 'Afterlife',
    description:
      'Afterlife Records is an electronic music label established in 2016 by artists Carmine Conte and Matteo Milleri, also known as the duo of Tale Of Us. The record label is known for its melodic techno-beats and dreamy sounds and has worked with artists such as Eric Prydz, ANNA, Mathame, Kevin de Vries and more...',
    videourl:
      'https://youtube.com/playlist?list=PLvmn9Ssy7H3xoXUIcX4Pb5mYpc-mz8MSz',
    price: 80,
    coverImg: 'afterlife.jpg',
    category: 'Electronica',
    location: 'Ibiza',
    locationImg: 'spain.jpeg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://www.after.life/',
    youtube: 'https://www.youtube.com/@Afterlifeofc',
    facebook: 'https://www.facebook.com/Afterlifeofc/',
    instagram: 'https://www.instagram.com/afterlife_ofc/',
    twitter: 'https://twitter.com/AfterlifeRecor1',
    spotify:
      'https://open.spotify.com/playlist/4YqlPeF8NyuiG6MymeSvK9?si=19163978b73b498a&nd=1',
    deezer: 'https://www.deezer.com/mx/artist/6620',
    apple: 'https://music.apple.com/mx/artist/afterlife/1186372246',
    soundcloud: 'https://soundcloud.com/afterlifeofc',
    tidal: 'https://listen.tidal.com/artist/21432206',
    wiki:
      'https://trifec.one/afterlife-records/#:~:text=Afterlife%20Records%20is%20an%20electronic,Kevin%20de%20Vries%20and%20more.',
    ticketmaster:
      'https://www.ticketmaster.com/afterlife-tickets/artist/2243592',
    tiktok: 'https://www.tiktok.com/@afterlife_ofc',
    napster: 'https://music.amazon.com.mx/artists/B08HL8D7GS/afterlife',
  },
]

export default CardData8
